"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var Teams = void 0;

var indexOf = [].indexOf || function (item) {
  for (var i = 0, l = this.length; i < l; i++) {
    if (i in this && this[i] === item) return i;
  }
  return -1;
};

Teams = function () {
  function Teams() {
    var takenSeats = void 0;
    var totalSeats = void 0;
    totalSeats = parseInt($(".seats-total").text());
    takenSeats = parseInt($(".seats-taken").text());
    $(document).ready(function () {
      var blocker = void 0;
      var editSeatButtonReset = void 0;
      var editSeatForm = void 0;
      var editSeatsTimeout = void 0;
      var email_re = void 0;
      var getChargePeriod = void 0;
      var getChargeToday = void 0;
      var helpClasses = void 0;
      var helpTimeout = void 0;
      var lastFour = void 0;
      var memberList = void 0;
      var membersUrl = void 0;
      var owner = void 0;
      var removeMember = void 0;
      var renderMembers = void 0;
      var renderUrl = void 0;
      var seatChangePreview = void 0;
      var seatFeePeriod = void 0;
      var seatFeeProrated = void 0;
      var showEditSeatHelp = void 0;
      var teamSlug = void 0;
      var timeoutEditSeats = void 0;
      var toggleEditSeats = void 0;
      var updateSeats = void 0;
      helpTimeout = null;
      editSeatsTimeout = null;
      memberList = $(".manage-seats");
      teamSlug = memberList.data("teamSlug");
      membersUrl = "/" + teamSlug + "/members/json/";
      renderUrl = "/" + teamSlug + "/members/render/";
      blocker = $(".add-member-form-blocker");
      email_re = /.+[@].+/;
      owner = typeof $(".manage-seats").data("owner") !== "undefined";
      editSeatForm = $("#edit-seat-number");
      seatFeeProrated = editSeatForm.data("seatProrated");
      seatFeePeriod = editSeatForm.data("seatPeriod");
      lastFour = editSeatForm.data("lastFour");
      helpClasses = {
        default: "initial-help",
        tooFew: "too-few-seats",
        invalid: "invalid-number",
        jsonError: "json-error",
        successUp: "confirm-charge",
        successDown: "confirm-reduction",
        sameNumber: "same-number",
        cardError: "card-error",
        waiting: "waiting"
      };
      renderMembers = function renderMembers(members, container, action) {
        var membersHtml = void 0;
        members = JSON.stringify({
          team_members: members
        });
        membersHtml = "";
        $.ajax({
          type: "POST",
          url: renderUrl,
          data: members,
          success: function success(data, status) {
            $(container).parent().find(".loading").removeClass("visible").addClass("hidden");
            if (action === "prepend") {
              return $(container).prepend($(data)).css("marginTop", "-130px").animate({
                marginTop: 0
              });
            } else {
              return $(container)[action]($(data));
            }
          }
        });
      };
      updateSeats = function updateSeats(taken, total) {
        if (total == null) {
          total = totalSeats;
        }
        takenSeats = taken;
        totalSeats = total;
        $("span.seats-taken").text(taken);
        $("span.seats-total").text(total);
        if (takenSeats < totalSeats) {
          blocker.hide();
        } else {
          blocker.show();
        }
      };
      removeMember = function removeMember(memberId, userId, memberEl) {
        var url = void 0;
        url = "/" + teamSlug + "/members/remove/" + memberId + "/";
        if (userId !== false) {
          url = url + userId + "/";
        }
        return $.ajax({
          type: "GET",
          url: url,
          success: function success(data, status) {
            if (data.ok) {
              memberEl.slideUp({
                duration: 400,
                complete: function complete() {
                  return $(this).remove();
                }
              });
              return updateSeats(takenSeats - 1);
            } else {
              return console.log(data, status);
            }
          }
        });
      };
      showEditSeatHelp = function showEditSeatHelp(helpClass) {
        var notErrorStates = void 0;
        var selector = void 0;
        var successStates = void 0;
        notErrorStates = ["default", "successUp", "successDown", "waiting"];
        successStates = ["successUp", "successDown"];
        selector = "." + helpClasses[helpClass];
        clearTimeout(helpTimeout);
        return helpTimeout = setTimeout(function () {
          $(".edit-seat-help").hide();
          $(selector).show();
          if (indexOf.call(notErrorStates, helpClass) >= 0) {
            $(".seat-number").removeClass("error");
          } else {
            $(".seat-number").addClass("error");
          }
          if (indexOf.call(successStates, helpClass) >= 0) {
            return editSeatButtonReset();
          }
        }, 200);
      };
      getChargeToday = function getChargeToday(newSeats) {
        var chargeToday = void 0;
        chargeToday = ((newSeats - totalSeats) * seatFeeProrated).toFixed(2);
        if (chargeToday <= 0) {
          chargeToday = "0.00";
        }
        return chargeToday;
      };
      getChargePeriod = function getChargePeriod(newSeats) {
        var chargePeriod = void 0;
        chargePeriod = (newSeats * seatFeePeriod).toFixed(2);
        return chargePeriod;
      };
      seatChangePreview = function seatChangePreview(newSeats) {
        var helpClass = void 0;
        helpClass = "default";
        if (isNaN(newSeats) || newSeats < 1) {
          helpClass = "invalid";
        } else if (newSeats < takenSeats) {
          $(".seat-overage").text(takenSeats - newSeats);
          helpClass = "tooFew";
        } else {
          $(".seat-price-today").text(getChargeToday(newSeats));
          $(".seat-price-period").text(getChargePeriod(newSeats));
        }
        return showEditSeatHelp(helpClass);
      };
      editSeatButtonReset = function editSeatButtonReset() {
        var button = void 0;
        var buttonSpan = void 0;
        var defaultText = void 0;
        button = $(".edit-seat-number-submit");
        buttonSpan = button.find("span");
        defaultText = button.data("default");
        button.data("confirm", "").removeClass("confirm processing success failure");
        buttonSpan.text(defaultText);
        return button.show();
      };
      toggleEditSeats = function toggleEditSeats() {
        var editSeats = void 0;
        editSeats = $("section.edit-seat-number");
        clearTimeout(editSeatsTimeout);
        if (editSeats.is(":visible")) {
          return editSeats.slideUp();
        } else {
          editSeatButtonReset();
          return editSeats.slideDown();
        }
      };
      timeoutEditSeats = function timeoutEditSeats() {
        var editSeats = void 0;
        editSeats = $("section.edit-seat-number");
        if (editSeats.is(":visible")) {
          return editSeatsTimeout = setTimeout(function () {
            return editSeats.slideUp();
          }, 7000);
        }
      };
      updateSeats(takenSeats);
      $.getJSON(membersUrl, function (_ref) {
        var team = _ref.team,
            pending_invites = _ref.pending_invites,
            team_members = _ref.team_members;

        var members = void 0;
        updateSeats(team.seats.taken, team.seats.total);
        if (owner) {
          members = pending_invites.concat(team_members);
        } else {
          members = team_members;
        }
        renderMembers(members, "#current-members", "append");
      });
      $("#seat-number").on("keyup", function (e) {
        var newSeats = void 0;
        newSeats = parseInt($(this).val());
        seatChangePreview(newSeats);
        return editSeatButtonReset();
      }).on("keydown", function (e) {
        if (e.keyCode === 13) {
          return e.preventDefault();
        }
      }).on("blur", function (e) {
        var newSeats = void 0;
        newSeats = parseInt($(this).val());
        if (isNaN(newSeats) || newSeats < 1) {
          newSeats = totalSeats;
          $(this).val(newSeats);
        }
        return seatChangePreview(newSeats);
      });
      $("#edit-seat-number").submit(function (e) {
        var button = void 0;
        var buttonSpan = void 0;
        var chargeToday = void 0;
        var helpClass = void 0;
        var newSeats = void 0;
        var num = void 0;
        var params = void 0;
        var text = void 0;
        var url = void 0;
        e.preventDefault();
        button = $(this).find(".edit-seat-number-submit");
        buttonSpan = button.find("span");
        if (button.data("confirm") !== "true") {
          newSeats = parseInt($("#seat-number").val());
          chargeToday = getChargeToday(newSeats);
          if (newSeats === totalSeats) {
            return showEditSeatHelp("sameNumber");
          } else if (newSeats < takenSeats) {
            return false;
          } else if (newSeats < totalSeats) {
            num = totalSeats - newSeats;
            text = num === 1 ? num + " Seat" : num + " Seats";
            buttonSpan.text("Remove " + text);
          } else {
            buttonSpan.text("Charge $" + chargeToday + " on " + lastFour);
          }
          button.data("confirm", "true");
          button.addClass("confirm");
          return $(".charge-amt").text(chargeToday);
        } else {
          url = $(this).attr("action");
          newSeats = $(this).find("#seat-number").val();
          params = {
            seats: newSeats
          };
          helpClass = "default";
          if (isNaN(newSeats) || parseInt(newSeats) === 0) {
            helpClass = "invalid";
          } else {
            if (newSeats >= takenSeats) {
              button.addClass("processing");
              $.post(url, params, function (_ref2, status) {
                var error = _ref2.error,
                    subscription = _ref2.subscription;

                if (error) {
                  showEditSeatHelp("cardError");
                  editSeatButtonReset();
                }
                if (newSeats < totalSeats) {
                  showEditSeatHelp("successDown");
                } else {
                  showEditSeatHelp("successUp");
                }
                return updateSeats(takenSeats, subscription.quantity);
              });
            } else {
              $(".seat-overage").text(takenSeats - newSeats);
              helpClass = "tooFew";
            }
          }
          return showEditSeatHelp(helpClass);
        }
      });
      $(".new-member-email").on("keyup", function (e) {
        var email = void 0;
        email = $("#new-member-email").val();
        if (email_re.exec(email)) {
          return $(".add-member-notification").text("");
        }
      });
      $(".add-member-btn").on("click", function (e) {
        var addBtn = void 0;
        var email = void 0;
        var params = void 0;
        var url = void 0;
        e.preventDefault();
        addBtn = $(this);
        url = "/" + teamSlug + "/members/invite/";
        email = $("#new-member-email").val();
        if (email_re.exec(email)) {
          params = {
            email: email
          };
          addBtn.prop("disabled", true);
          $.post(url, params, function (_ref3, status) {
            var success = _ref3.success,
                invitation = _ref3.invitation,
                team = _ref3.team;

            addBtn.prop("disabled", false);
            if (success) {
              renderMembers([invitation], "#current-members", "prepend");
              updateSeats(team.seats.taken, team.seats.total);
              return $(".new-member-email").val("");
            } else {
              return $(".add-member-notification").text("Could not add team member");
            }
          }).fail(function () {
            return addBtn.prop("disabled", false);
          });
        } else {
          $(".add-member-notification").text("This doesn’t look like a valid email address");
        }
      });
      $("#current-members").on("click", ".remove-member", function (e) {
        var confirm = void 0;
        var memberEl = void 0;
        var memberId = void 0;
        var userId = void 0;
        e.preventDefault();
        memberEl = $(this).parents(".team-member-detail");
        memberId = memberEl.data("memberId");
        userId = memberEl.data("userId");
        confirm = memberEl.find(".team-member-confirm-remove");
        return confirm.fadeIn().on("click", ".yes-button", function (e) {
          if (typeof userId === "number") {
            return removeMember(memberId, userId, memberEl);
          } else {
            return removeMember(memberId, false, memberEl);
          }
        }).on("click", ".no-button", function (e) {
          return confirm.fadeOut();
        });
      }).on("click", ".resend-invite", function (e) {
        var linkEl = void 0;
        var memberToken = void 0;
        var params = void 0;
        e.preventDefault();
        linkEl = $(this);
        memberToken = $(this).parents(".team-member-detail").attr("data-token");
        params = {
          token: memberToken
        };
        $.ajax({
          type: "POST",
          url: "/" + teamSlug + "/members/invite/resend/",
          data: params,
          success: function success(data, status) {
            linkEl.addClass("confirmed");
            return setTimeout(function () {
              return linkEl.removeClass("confirmed");
            }, 3000);
          }
        });
      }).on("click", ".copy-invite-url", function (e) {
        var linkInput = void 0;
        e.preventDefault();
        linkInput = $(this).parents(".team-member-detail").find(".team-member-invite-url");
        if (linkInput.is(":visible")) {
          linkInput.slideUp();
        } else {
          linkInput.slideDown();
          linkInput.select();
        }
      }).on("click", ".team-member-confirm-remove-close", function (e) {
        e.preventDefault();
        return $(this).parents(".team-member-confirm-remove").fadeOut();
      });
      $("#new-member-email").focus(function () {
        return $(".add-member-btn").addClass("darken");
      });
      $("#new-member-email").blur(function () {
        return $(".add-member-btn").removeClass("darken");
      });
      $(".show-edit-seat-number").on("click", function (e) {
        e.preventDefault();
        return toggleEditSeats();
      });
      return $(".add-member-form-blocker a").on("click", function (e) {
        e.preventDefault();
        return toggleEditSeats();
      });
    });
  }

  return Teams;
}();

exports.default = Teams;